import { render, staticRenderFns } from "./DbMonitor.vue?vue&type=template&id=97d14c8c"
import script from "./DbMonitor.vue?vue&type=script&lang=js"
export * from "./DbMonitor.vue?vue&type=script&lang=js"
import style0 from "./DbMonitor.vue?vue&type=style&index=0&id=97d14c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports